<template>
  <Loading
    v-if="composable.loading.setting.isShow"
    :content="composable.loading.setting.content"
  />

  <div
    v-if="page === 'initialization'"
    class="page"
  />

  <div
    v-else-if="page === 'query'"
    class="page"
  >
    <Header
      :setting="{
        title: '預約查詢',
        hasCancelMethod: false,
      }"
    />
    <div class="page__form mv8">
      <input
        type="text"
        placeholder="身份證/Resident ID No."
        v-model.trim="queryForm.id"
        class="mb5"
      >
      <input
        type="text"
        placeholder="西元生日/Birth Date(YYYYMMDD)"
        v-model.trim="queryForm.birthdate"
        class="mb5"
      >
    </div>
    <div
      @click="query"
      class="label label--primary mb4"
    >
      查詢
    </div>
    <div
      @click="clearQueryForm"
      class="label label--secondary mb4"
    >
      清除查詢資訊
    </div>
  </div>

  <div
    v-else-if="page === 'showing'"
    class="page"
  >
    <Header
      :setting="{
        title:'預約查詢',
        hasCancelMethod: !(composable.member.info.status === 'in'),
      }"
      @cancel="page='query'"
      class="mb4"
    />
    <div
      v-if="appointments.length===0"
      class="mv3"
    >
      查無預約資訊
    </div>
    <template
      v-for="name in namesSet"
      :key="name"
    >
      <div
        v-if="appointments.find(appointment=>appointment.name===name)
          !==undefined"
        class="row--start mb3"
      >
        <div class="label label--secondary ml3">
          {{ name }}
        </div>
      </div>
      <template
        v-for="(appointment,index) in appointments"
        :key="appointment"
      >
        <Appointment
          v-if="appointment.name === name"
          :appointment="appointment"
          @showCancelConfirmation="showCancelConfirmation(index)"
          class="mb4"
        />
      </template>
    </template>
  </div>

  <Death
    v-else
    :message="composable.death.message"
    :page="page"
  />

  <Modal
    v-if="composable.modal.setting.isShow"
    :setting="composable.modal.setting"
    @close="composable.modal.close"
    @confirm="cancel"
  />
</template>

<script>
import { ref, onMounted, reactive } from 'vue';
import composable from '@/composable/index';
import spiderman from '@/spiderman/index';
import api from '@/api/index';
import Appointment from './components/Appointment.vue';

export default {
  components: { Appointment },
  setup() {
    const page = ref('initialization');
    const queryForm = reactive({
      id: '',
      birthdate: '',
    });
    const appointments = ref([]);
    const namesSet = ref([]);
    let cancelIndex = -1;

    onMounted(() => {
      if (composable.member.info.status === 'in') {
        queryForm.id = composable.member.info.twid;
        queryForm.birthdate = composable.member.info.birthdate;
        query();
        return;
      }

      page.value = 'query';
    });

    function clearQueryForm() {
      queryForm.id = '';
      queryForm.birthdate = '';
    }

    async function query() {
      try {
        spiderman.form.verify(queryForm);
        queryForm.birthdate = spiderman.moment(queryForm.birthdate)
          .format('YYYY-MM-DD');

        composable.loading.show('查詢中，請稍候');

        const response = await api.appointment.query(
          composable.member, queryForm,
        );

        appointments.value = response;
        namesSet.value = spiderman.generate.valuesArray({
          array: appointments.value,
          key: 'name',
        });

        page.value = 'showing';
      } catch (error) {
        composable.modal.alert(error);
      } finally {
        composable.loading.close();
      }
    }

    function showCancelConfirmation(index) {
      composable.modal.confirm(
        `確定刪除 
        ${appointments.value[index].name}
        ${appointments.value[index].doctor}醫師 ${spiderman.moment(
  appointments.value[index].date,
).format('MM/DD')} ${appointments.value[index].timeSlotName}診嗎？
        `,
      );
      cancelIndex = index;
    }

    async function cancel() {
      try {
        composable.modal.close();
        composable.loading.show('預約刪除中，請稍候');

        await api.appointment.cancel(
          composable.member, appointments.value[cancelIndex],
        );
        appointments.value.splice(cancelIndex, 1);

        composable.modal.popup('已取消預約');
      } catch (error) {
        composable.modal.alert(error);
      } finally {
        composable.loading.close();
      }
    }

    return {
      page,
      composable,
      queryForm,
      clearQueryForm,
      query,
      namesSet,
      appointments,
      showCancelConfirmation,
      cancel,
    };
  },
};
</script>
